var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"fs-adjustments"},[_c('fs-range-filter-wrapper',{attrs:{"min":"-1","max":"1","defaultValue":"0","routerLink":'/adjustments',"label":"menu.contrast"},model:{value:(_vm.value.contrast),callback:function ($$v) {_vm.$set(_vm.value, "contrast", $$v)},expression:"value.contrast"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }